export const URLEndPoint ="https://socket.enerex.com/generator/PartialSubmit?subscription-key="

export const BOUNDARIES = [
    { name: "Not Specified", id: 2924 },
    { id: 2925, name: "Residential" },
    { id: 2926, name: "Small C&I" },
    { id: 2922, name: "Medium C&I" },
    { id: 2921, name: "Large C&I" },
];